import { Navigate, useNavigate, useParams } from "react-router-dom";
import { config } from "../AppConfig";

const VerifyEmail = (props) => {
  const { token } = useParams();
  const navigate = useNavigate();
  window.location.href = `${config.url.API_BASE}/api/ajax/v1/auth/email/verify/${token}`;
};

export default VerifyEmail;
